import React from "react";
import { useDispatch, useSelector } from "react-redux";
import TheHeader from "../comm/inCar/TheHeader";
import TheNav from "../comm/inCar/TheNav";
import TheFooter from "../comm/inCar/TheFooter";
import ApoDocFormPop from "./apoDocFormPop";
import ApoDocHdwtRegPop from "./apoDocHdwtRegPop";
import {
  setApoDocHdwtData,
  setApoDocCnfmYn,
  setModifyApoDocCnfmYn,
  handleCnfmYnAllChecked,
} from "src/modules/apoDocForm";
import { setECleanYn } from 'src/modules/insert'
import {
  CButton,
  CRow,
  CCol,
  CCardHeader,
  CCardBody,
  CFormGroup,
  CContainer,
} from "@coreui/react";
import ApiHelper from "src/utils/api/api_helper";
import Swal from "sweetalert";
import { useHistory, useLocation } from "react-router-dom";

const ApoDocFormPage = () => {
  const state = useSelector((state) => state);
  const { apoDocCnfmYn } = state.apoDocForm;
  const { qualificationYn, fireCrerYn } = state.main;
  const dispatch = useDispatch();
  const history = useHistory();
  const pathParam = Number(useLocation().pathname.substr(-1, 1));
  const etcAfcoList = ['10025', '10010', '10011', '10026', '10009', '10008', '10024', '10013', '10004', '10021', '10031' , '10029', '10005', '10012', '10023', '10022', '10001'];
  const [apoDocList, setApoDocList] = React.useState([]);
  const [qlfcDocList, setQlfcDocList] = React.useState([]);
  const [hasOtherSignM, setHasOtherSignM] = React.useState(false);
  const [apoDocRegPop, setApoDocRegPop] = React.useState({
    isOpen: false,
    afcrNo: "",
  });
  const [hdwtRegPop, setHdwtRegPop] = React.useState({
    isOpen: false,
  });
  const [showPopup, setShowPopup] = React.useState(false);
  const { eCleanYn } = state.insert.reqTaskInfo;
  const [allCheck, setAllCheck] = React.useState(false);

  function openPopup() {
    setShowPopup(true);
  }
  async function closePopup() {
    dispatch(setECleanYn(0));
    await setShowPopup(false);
  }

  function onStChange (e) {
    const { value } = e.target;
    dispatch(setECleanYn(value));
  }

  const handleGoToNext = async () => {
    await setShowPopup(false);
    if(!allCheck){
      setApoDocRegPop({ isOpen: true, afcrNo : '10010' });
    }
    await dispatch(setECleanYn(eCleanYn));
  };

  const onRegPopClose = (afcrNo) => {
    setApoDocRegPop({ isOpen: false });
    document.getElementsByTagName("body")[0].style.overflow = "scroll";
    dispatch(setModifyApoDocCnfmYn(String(afcrNo), false));
  };

  const handelHdwtRegPopClose = () => {
    setHdwtRegPop({ isOpen: false });
    document.getElementsByTagName("body")[0].style.overflow = "scroll";
  };

  function showQlfcDoc(e) {
    const { afcrCatCd } = e.target.dataset;
    let afcrNo = afcrCatCd === '10' ? 99998 : 99999;

    setApoDocRegPop({ isOpen: true, afcrNo });
  };

  const onRegistryClick = async (e) => {
    const { afcrNo } = e.target.dataset;
    
    if( state.insert.reqTaskInfo.stCd === "10" || state.insert.reqTaskInfo.stCd === "99") {
      let checked = apoDocCnfmYn.filter((item) => item.afcrNo === afcrNo && item.cnfmYn);
      if(checked.length) return dispatch(setModifyApoDocCnfmYn(String(afcrNo), true));
    }
    if(afcrNo === "10010"){
      openPopup();
    }else{
      setApoDocRegPop({ isOpen: true, afcrNo });
    }

    
  };

  async function onChangeCnfmYnAll(e) {
    const isChecked = e.target.checked;

    if(apoDocList.filter((item) => item.AFCR_CAT_CD === '20').length > 0 && isChecked){
      setAllCheck(true);
      openPopup();
    }else if(!isChecked){
      setAllCheck(false);
    }

    await dispatch(handleCnfmYnAllChecked());
    // if(isChecked && hasOtherSignM) {
    //   Swal(
    //     "위촉서류",
    //     "한화생명의 경우 별도의 자필작성이 있으니 내용을 확인하시고, 반드시 자필작성을 진행해주세요.",
    //     'info'
    //   ).then(() => {
    //     setApoDocRegPop({ isOpen: true, afcrNo: '10005' });
    //   });
    // }
  }

  const handelHdwtSign = () => {
    let cnt = 0;
    for (let item of state.apoDocForm.apoDocCnfmYn) {
      if (item.cnfmYn){
        cnt ++;
      }
    }

    if(cnt === 0)
      return Swal(
        "서류작성",
        "하나 이상의 위촉서류를 확인하셔야 서명이 가능합니다.",
        "info"
      );

    setHdwtRegPop({ isOpen: true });
  };

  const handleHdwtForApoDocSave = (e, nextPage) => {
    let params = {};
    let data = [];
    let chkAfcrArr = [];
    let unchkAfcrArr = [];
    let kbChkYn = apoDocCnfmYn.filter((item) => item.afcrNo === '10026' && item.cnfmYn).length;
    let dyChkYn = apoDocCnfmYn.filter((item) => item.afcrNo === '10003' && item.cnfmYn).length;
    let lnChkYn = apoDocCnfmYn.filter((item) => item.afcrNo === '10006' && item.cnfmYn).length;
    let hhChkYn = apoDocCnfmYn.filter((item) => item.afcrNo === '20022' && item.cnfmYn).length;
    let lkyChkYn = apoDocCnfmYn.filter((item) => item.afcrNo === '10004' && item.cnfmYn).length;
    let mtChkYn = apoDocCnfmYn.filter((item) => item.afcrNo === '10010' && item.cnfmYn).length;

    if(mtChkYn == 0){ // 메트라이프 : 임시저장 및 반려진행 중 해당 보험사 체크해체 했을 때 eCleanYn처리
      dispatch(setECleanYn(0));
    }
    for (let item of state.apoDocForm.apoDocHdwtInfo) {
      if (item.update) {
        data.push({ hdwtCatCd: item.hdwtCatCd, imgData: item.data });
      }
    }
    
    chkAfcrArr = state.apoDocForm.apoDocCnfmYn.filter((item) => item.cnfmYn);
    unchkAfcrArr = state.apoDocForm.apoDocCnfmYn.filter((item) => !item.cnfmYn);

    params.reqNo = state.insert.reqTaskInfo.reqNo;
    params.data = JSON.stringify(data);
   // params.eCleanYn = state.apoDocForm.eCleanYn;

    if (nextPage) {
      // for (let item of state.apoDocForm.apoDocCnfmYn) {
      //   if (!item.cnfmYn)
      //     return Swal(
      //       "서류작성",
      //       "모든 위촉서류를 확인하셔야 서명이 가능합니다.",
      //       "info"
      //     );
      // }
      // if (hasOtherSignM) {
      //   if (!state.apoDocForm.apoDocHdwtInfo[2].data && hhChkYn > 0) {
      //     return Swal(
      //       '서류작성',
      //       '한화생명 위촉서류에 자필작성 후, 서명을 하셔야 다음으로 이동이 가능합니다.',
      //       'error',
      //     );
      //   }
      // }
      // if (hasOtherSignH) {
      //   if (!state.apoDocForm.apoDocHdwtInfo[1].data) {
      //     return Swal(
      //       '서류작성',
      //       '흥국생명 위촉서류에 자필작성 후, 서명을 하셔야 다음으로 이동이 가능합니다.',
      //       'error',
      //     );
      //   }
      // }
      if (!state.apoDocForm.apoDocHdwtInfo[0].data) {
        return Swal(
          '서류작성',
          '서명을 하셔야 다음으로 이동이 가능합니다.',
          'error',
        );
      }
    }
    ApiHelper.request(
      ApiHelper.methods.post,
      "/cust/request/tempSaveStep4And5",
      params
    )
      .then(({ data }) => {
        let newParams = { reqNo: state.insert.reqTaskInfo.reqNo };

        if (data.status === "SUCCESS") {
          newParams.chkAfcrArr = JSON.stringify(chkAfcrArr);
          newParams.unchkAfcrArr = JSON.stringify(unchkAfcrArr);
          newParams.eCleanYn = state.insert.reqTaskInfo.eCleanYn;
          
          ApiHelper.request(
            ApiHelper.methods.post,
            "/cust/request/tempSaveStep5",
            newParams
          )
            .then(({ data }) => {
              if (data.status === "SUCCESS") {
                if (nextPage) {
                  let msg = `
                    - 메트라이프, KB라이프생명, 하나생명: 설계사 핸드폰으로 URL발송
                    (모바일 동의 후 위촉가능)\n
                    - DB생명, 삼성생명, 처브라이프 : 출력서류에 추가 자필서명 후 제출  
                  `;

                  if(kbChkYn === 1 || dyChkYn === 1 || lnChkYn === 1) {
                    msg += `
                      ${dyChkYn === 1 ? '- 동양' : ''}${lnChkYn === 1 ? dyChkYn === 1 ? '/라이나' : '- 라이나' : ''}${dyChkYn === 1 || lnChkYn === 1 ? '생명은 해당 지점 총무에게 서류출력 요청 바랍니다.' : ''}`;
                  } 
                  // 24.01.18 업체요청으로 팝업 문구 삭제
                  // if(lkyChkYn === 1){
                  //     msg += `\n
                  //     - 교보생명 : 경력증명서 추가 제출 필요.
                  //     (손보 경력이 있을경우에도 필수 첨부)\n
                  //   `;
                  // }
                    Swal(
                      // `${kbChkYn === 1 ? 'KB생명' : ''}
                      //  ${dyChkYn === 1 ? '동양생명' : ''}
                      //  ${lnChkYn === 1 ? '라이나생명': ''}`, 
                      '안내사항',
                      msg,
                      "info"
                    ).then(() => history.push(`/${state.main.corpNm}/${pathParam + 1}`));
                } else {
                  return Swal("", "임시저장 되었습니다.", "success");
                }
              }
            })
            .catch((err) => {
              console.error(err);
            });
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  React.useEffect(() => {
    let rsltHdwtData = [];
    let rsltcnfmData = [];

    ApiHelper.request(ApiHelper.methods.post, "/cust/request/apoDocList", {
      corpNo: state.main.corpNo,
      taskNo: state.main.taskNo,
    })
      .then(({ data }) => {
        if (data.status === "SUCCESS") {
          let result = data.data;
          let apoDocList;
          let qlfcDocList = result.filter((item) => item.FORM_CAT_CD === '30');

          // 유자격자인 경우
          if(qualificationYn === '1') {
            apoDocList = result.filter((item) => item.FORM_CAT_CD === '10' && item.AFCR_CAT_CD !== '10');
          // 설계사인 경우
          } else {
            // 손보경력인 경우
            if(fireCrerYn === '1') {
              // 메리츠 전속인 경우 메리츠 제외하고 보여줌(롯데손보만)
              if(state.main.exclYn === '1') {
                apoDocList = result.filter((item) => item.FORM_CAT_CD === '10' && item.AFCR_NO !== '20006');
              // 메리츠 비전속인 경우 메리츠만 보여줌(롯데손보 제외)
              } else {
                apoDocList = result.filter((item) => item.FORM_CAT_CD === '10' && item.AFCR_NO !== '20021');
              }
            // 손보신입인 경우
            // #16311 2024.12.19 메리츠만 보이도록 수정
            } else {
              apoDocList = result.filter((item) => item.FORM_CAT_CD === '10' && item.AFCR_NO !== '20021');
            }
          }
          
          for (let i of result) {
            if (i.AFCR_NO === '10005') {
              setHasOtherSignM(true);
            }
          }
          
          if(qualificationYn === '1') setQlfcDocList(qlfcDocList);
          setApoDocList(apoDocList);
        }
      })
      .catch((err) => {
        console.error(err);
      });

    const setApoDocFormInitData = async () => {
      await ApiHelper.request(
        ApiHelper.methods.post,
        "/cust/request/hdwtInfo2",
        {
          reqNo: state.insert.reqTaskInfo.reqNo,
        }
      )
        .then(({ data }) => {
          if (data.status === "SUCCESS") {
            rsltHdwtData = data.data;
          }
        })
        .catch((err) => {
          console.error(err);
        });

      await ApiHelper.request(
        ApiHelper.methods.post,
        "/cust/request/apoDocCnfmInfo",
        {
          reqNo: state.insert.reqTaskInfo.reqNo,
          taskNo: state.main.taskNo,
        }
      )
        .then(({ data }) => {
          if (data.status === "SUCCESS") {
            let result = data.data;
            
            // 유자격자인 경우
            if(qualificationYn === '1') {
              result = result.filter((item) => !(item.AFCR_CAT_CD === '10' && item.FORM_CAT_CD === '10'));
            // 설계사인 경우
            } else {
              // 손보경력인 경우
              if(fireCrerYn === '1') {
                // 메리츠 전속인 경우 메리츠 제외하고 보여줌(롯데손보만)
                if(state.main.exclYn === '1') {
                  result = result.filter((item) => item.FORM_CAT_CD !== '30' && item.AFCR_NO !== '20006');
                // 메리츠 비전속인 경우 메리츠만 보여줌(롯데손보 제외)
                } else {
                  result = result.filter((item) => item.FORM_CAT_CD !== '30' && item.AFCR_NO !== '20021');
                }
              // 손보신입인 경우
              // #16311 2024.12.19 메리츠만 보이도록 수정
              } else {
                result = result.filter((item) => item.FORM_CAT_CD !== '30' && item.AFCR_NO !== '20021');
              }
            }
            
            if (result.length) {
              result.forEach((item) => {
                rsltcnfmData.push({
                  afcrNo: item.AFCR_NO,
                  formNo: item.FORM_NO,
                  cnfmYn: item.AFCR_NO === ''
                    ? qualificationYn === '1'
                      ? true
                      : false
                    : item.CNFM_DTM != null 
                      ? true 
                      : false,
                  update: item.AFCR_NO === ''
                    ? true
                    : false,
                });
              });
            }
          }
        })
        .catch((err) => {
          console.error(err);
        });

      await dispatch(setApoDocHdwtData(rsltHdwtData, true));
      await dispatch(setApoDocCnfmYn(rsltcnfmData));
    };

    if (state.apoDocForm.isFirst) {
      setApoDocFormInitData();
    }
  }, []);

  return (
    <>
      <TheHeader />
      <div className="c-main">
        <TheNav step={state.main.step} />
        <CContainer className="text-left">
          <h5>
            <b>
              보험사별 위촉서류를 작성합니다.<br></br>위촉서류를 모두
              확인하시고, 서명을 해주세요.
            </b>
          </h5>
          {/* {hasOtherSignM
            && (
            <span className="subSpan">
              <h6>
                <b>한화생명의 경우 별도의 자필작성이 있으니 꼭 확인 바랍니다.</b>
              </h6>
            </span>
            )} */}
        </CContainer>
        { qualificationYn === '1'
          && 
          <>
            <CCardHeader className="apoDoc-card-header">유자격자 고지사항</CCardHeader>
            <CCardBody className="etc-card-body">
             {qlfcDocList.map((item) => {
               return (
                <CFormGroup
                  row
                  className="mb-3 formCheckbox"
                  key={item.FORM_NO}
                >
                  <CCol xs="2">
                    <label className="component-checkbox">
                      <input 
                        type="checkbox" 
                        id={`apoDoc${item.FORM_NO}`}
                        name={`apoDoc${item.FORM_NO}`}
                        defaultChecked={true}
                        data-afcr-cat-cd={item.AFCR_CAT_CD}
                        disabled
                        onClick={showQlfcDoc}
                        />
                      <i />
                    </label>
                  </CCol>
                  <CCol xs="10">
                    <CButton
                      className='isChecked'
                      color="primary"
                      variant="outline"
                      block
                      data-afcr-cat-cd={item.AFCR_CAT_CD}
                      onClick={showQlfcDoc}
                      >
                        {item.FORM_NM}
                    </CButton>
                  </CCol>
                </CFormGroup>
                )
              })}
            </CCardBody>
          </>
        }
        { (qualificationYn === '1' &&
          apoDocList.length === 1)
          ?
          <article className="ui-check"></article>
          :
          <article className="ui-check">
            <div className="component-checkbox">
              <label>
                <input 
                  type="checkbox" 
                  id="checkAll" 
                  onChange={(e) => onChangeCnfmYnAll(e)} 
                  checked={apoDocCnfmYn.filter((item) => item.cnfmYn).length === apoDocCnfmYn.length}
                  disabled={
                    state.insert.reqTaskInfo.stCd === "10" ||
                    state.insert.reqTaskInfo.stCd === "99"
                      ? false
                      : true
                  }
                />
                <i />
                <span className="txt-label" htmlFor="checkAll">전체선택</span>
              </label>
            </div>
          </article>
        }
        { qualificationYn === '0' &&
          apoDocList.filter((item) => item.AFCR_CAT_CD === '10').length > 0
          &&
          <>
          <CCardHeader className="apoDoc-card-header">손해보험</CCardHeader>
          <CCardBody className="etc-card-body">
            {apoDocList
            .filter((item) => item.AFCR_CAT_CD === '10')
            .map((apoDoc) => {
              let boolVal = false;
  
              state.apoDocForm.apoDocCnfmYn.forEach((item) => {
                if (apoDoc.AFCR_NO === item.afcrNo && item.cnfmYn) {
                  boolVal = true;
                }
              });

              return (
                <CFormGroup
                  row
                  className="mb-3 formCheckbox"
                  key={apoDoc.FORM_NO}
                >
                  <CCol xs="2">
                    <label className="component-checkbox">
                      <input 
                        type="checkbox" 
                        id={`apoDoc${apoDoc.FORM_NO}`}
                        name={`apoDoc${apoDoc.FORM_NO}`}
                        readOnly
                        data-afcr-no={apoDoc.AFCR_NO}
                        onClick={onRegistryClick}
                        checked={boolVal}
                      />
                      <i />
                    </label>
                  </CCol>
                  <CCol xs="10">
                  <CButton
                      className={boolVal ? 'isChecked' : ''}
                      color="primary"
                      variant="outline"
                      data-afcr-no={apoDoc.AFCR_NO}
                      block
                      onClick={onRegistryClick}
                    >
                      {apoDoc.FORM_NM}
                    </CButton>
                  </CCol>
                </CFormGroup>
              )
            })           
          }
          </CCardBody>
          </>
        }
        {
           apoDocList.filter((item) => item.AFCR_CAT_CD === '20').length > 0
           &&
           <>
           <CCardHeader className="apoDoc-card-header">생명보험 - 서류접수 보험사</CCardHeader>
           <CCardBody className="etc-card-body">
            {apoDocList
            .filter((item) => item.AFCR_CAT_CD === '20')
            .filter((item) => etcAfcoList.indexOf(item.AFCR_NO) === -1)
            .map((apoDoc) => {
              let boolVal = false;
              state.apoDocForm.apoDocCnfmYn.forEach((item) => {
                if (apoDoc.AFCR_NO === item.afcrNo && item.cnfmYn) {
                  boolVal = true;
                }
              });

              return (
              <CFormGroup
                row
                className="mb-3 formCheckbox"
                key={apoDoc.FORM_NO}
              >
                <CCol xs="2">
                    {/* {apoDoc.AFCR_NO === "10005" ? ( */}
                      {/* <label className="component-checkbox">
                        <input 
                          type="checkbox" 
                          id={`apoDoc${apoDoc.FORM_NO}`}
                          name={`apoDoc${apoDoc.FORM_NO}`}
                          readOnly
                          data-afcr-no={apoDoc.AFCR_NO}
                          onClick={onRegistryClick}
                          checked={!!(state.apoDocForm.apoDocHdwtInfo[2].data && boolVal) ? true: false}
                        />
                        <i />
                      </label> */}
                    {/* ) : ( */}
                      <label className="component-checkbox">
                        <input 
                          type="checkbox" 
                          id={`apoDoc${apoDoc.FORM_NO}`}
                          name={`apoDoc${apoDoc.FORM_NO}`}
                          readOnly
                          data-afcr-no={apoDoc.AFCR_NO}
                          onClick={onRegistryClick}
                          checked={boolVal}
                        />
                        <i />
                      </label>
                 {/* )} */}
                </CCol>
                <CCol xs="10">
                <CButton
                    className={apoDoc.AFCR_NO === '10005'
                      ? !!(state.apoDocForm.apoDocHdwtInfo[2].data && boolVal) ? 'isChecked' : ''
                      : boolVal ? 'isChecked' : ''}
                    color="primary"
                    variant="outline"
                    data-afcr-no={apoDoc.AFCR_NO}
                    block
                    onClick={onRegistryClick}
                  >
                    {apoDoc.FORM_NM}
                  </CButton>
                </CCol>
              </CFormGroup>
            );
          })}
          </CCardBody>
         
          {apoDocList
            .filter((item) => etcAfcoList.indexOf(item.AFCR_NO) > -1).length > 0 
            && <CCardHeader className="apoDoc-card-header">생명보험 - 전자문서 보험사</CCardHeader>}
            <CCardBody className="etc-card-body">
            {apoDocList
            .filter((item) => item.AFCR_CAT_CD === '20')
            .filter((item) => etcAfcoList.indexOf(item.AFCR_NO) > -1)
            .map((apoDoc) => {
              let boolVal = false;
  
              state.apoDocForm.apoDocCnfmYn.forEach((item) => {
                if (apoDoc.AFCR_NO === item.afcrNo && item.cnfmYn) {
                  boolVal = true;
                }
              });
  
              return (
                <CFormGroup
                  row
                  className="mb-3 formCheckbox"
                  key={apoDoc.FORM_NO}
                >
                  <CCol xs="2">
                    <label className="component-checkbox">
                      <input 
                        type="checkbox" 
                        id={`apoDoc${apoDoc.FORM_NO}`}
                        name={`apoDoc${apoDoc.FORM_NO}`}
                        readOnly
                        data-afcr-no={apoDoc.AFCR_NO}
                        onClick={onRegistryClick}
                        checked={boolVal}
                      />
                      <i />
                    </label>
                  </CCol>
                  <CCol xs="10">
                    <CButton
                    className={boolVal ? 'isChecked' : ''}
                    color="primary"
                    variant="outline"
                    data-afcr-no={apoDoc.AFCR_NO}
                    block
                    onClick={onRegistryClick}
                    >
                      {apoDoc.FORM_NM}
                    </CButton>
                  </CCol>
                </CFormGroup>
              );
            })}
            </CCardBody>
          </>
        }
          <CCardBody className="bottom-card-body">
          <CRow className="text-left">
            <CCol xs="12">
              <p>
                선택하신 모든 보험사 위촉서류내용에 대해 충분히 이해하고 숙지하였으며,
                이에 대한 동의의 의사표시로 자필서명 합니다.
              </p>
            </CCol>
          </CRow>
          <CRow>
            <CCol xs="12">
              <CButton
                color="primary"
                block
                onClick={handelHdwtSign}
                disabled={
                  !(state.insert.reqTaskInfo.stCd === '10'
                  || state.insert.reqTaskInfo.stCd === '99')
                }
              >
                서명하기
              </CButton>
            </CCol>
          </CRow>
        </CCardBody>
      </div>
      <TheFooter
        step={state.main.step}
        handleHdwtForApoDocSave={handleHdwtForApoDocSave}
      />
      {apoDocRegPop.isOpen && (
        <ApoDocFormPop
          modal={true}
          afcrNo={apoDocRegPop.afcrNo}
          onClose={onRegPopClose}
        ></ApoDocFormPop>
      )}
      {hdwtRegPop.isOpen && (
        <ApoDocHdwtRegPop
          modal={true}
          etcYn={0}
          display={hdwtRegPop.isOpen ? "display" : ""}
          onClose={handelHdwtRegPopClose}
        ></ApoDocHdwtRegPop>
      )}
      {showPopup &&
        <div className="layer-popup">
          <div className="box-popup popup-sign">
            <button
              className="popup-close"
              onClick={closePopup}
              type="button"
            >
              {' '}
            </button>
            <div className="popup-title">메트라이프 위촉서류</div>
            <div className="popup-contents">
              <span className="txt-label">이클린서비스 조회(보험사기관련 내부징계 이력 보유 여부)</span>
              <div className="inline-label"></div>
              <fieldset className="radio-fileset">
              <div className="radio-inline">
                <label className="component-radio type-default">
                  <input type="radio" name="eCleanYn" value="0"
                    onChange={(e) => onStChange(e)}
                    checked={eCleanYn == '0'} />
                  <i />
                  <div className="text-label">아니오</div>
                </label>
                <label className="component-radio type-default">
                  <input type="radio" name="eCleanYn" value="1"
                  onChange={(e) => onStChange(e)}
                  checked={eCleanYn == '1' } />
                  <i/>
                  <div className="text-label">예</div>
                </label>
              </div>
              </fieldset>
            </div>
            <div className="popup-footer">
              <button className="btn-footer" type="button" onClick={() => closePopup()}>
                닫기
              </button>
               <button className="btn-footer type-solid" type="button" onClick={handleGoToNext}>
                확인
              </button>  
            </div>
          </div>
        </div>}
    </>
  );
};

export default ApoDocFormPage;
